import { entriesReducerFactory } from '@/fleet-configuration/data-fleet/reducers/entries-reducer-factory'
import { REMOVE_DEVICE_LAST_STATE, SET_DEVICE_LAST_STATE } from './devices-last-state-actions.js'

export const devicesLastStateReducer = entriesReducerFactory(SET_DEVICE_LAST_STATE, undefined, REMOVE_DEVICE_LAST_STATE)
